var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.562 110C216.562 168.866 168.849 216.562 110 216.562C51.1513 216.562 3.4375 168.866 3.4375 110C3.4375 51.1685 51.1513 3.4375 110 3.4375C168.849 3.4375 216.562 51.1685 216.562 110ZM110 131.484C99.0838 131.484 90.2344 140.334 90.2344 151.25C90.2344 162.166 99.0838 171.016 110 171.016C120.916 171.016 129.766 162.166 129.766 151.25C129.766 140.334 120.916 131.484 110 131.484ZM91.2343 60.4373L94.4217 118.875C94.5708 121.609 96.8318 123.75 99.5702 123.75H120.43C123.168 123.75 125.429 121.609 125.578 118.875L128.766 60.4373C128.927 57.4836 126.575 55 123.617 55H96.3823C93.4244 55 91.0731 57.4836 91.2343 60.4373V60.4373Z",
    fill: "#CA0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e5089a8e439d119ddd8261e851e1c243.svg";
export { ForwardRef as ReactComponent };